import { FunctionComponent } from "react";
import { useAuth } from "../../contexts/AuthContext";
import styles from "./AdminSideMenu.module.css";
import { Link, useLocation } from "react-router-dom"; // Import useLocation

const AdminSideMenu: FunctionComponent = () => {
    const { user, logout } = useAuth();
    const location = useLocation(); // Get current location

    const handleLogout = () => {
        logout();
    };

    return (
        <>
            <div className={styles.sideMenu}>
                <Link
                    to="/rooms"
                    className={`${styles.roomsMenu} ${location.pathname === '/rooms' || location.pathname === '/' ? styles.active : ''}`}
                >
                    <img className={styles.image41Icon} alt="" src="/image-41@2x.png" />
                    <div className={styles.rooms}>Rooms</div>
                </Link>

                <Link
                    to="/users"
                    className={`${styles.usersMenu} ${location.pathname === '/users' ? styles.active : ''}`}
                >
                    <div className={styles.users}>Users</div>
                    <img className={styles.image42Icon} alt="" src="/image-42@2x.png" />
                </Link>

                <Link
                    to="/session-history"
                    className={`${styles.sessionsMenu} ${location.pathname === '/session-history' ? styles.active : ''}`}
                >
                    <div className={styles.users}>History</div>
                    <img className={styles.imageHistoryIcon} alt="Session History" src="/icon-history.svg" />
                </Link>

                <Link
                    to="/transcriptions"
                    className={`${styles.transcriptionsMenu} ${location.pathname === '/transcriptions' ? styles.active : ''}`}
                >
                    <div className={styles.users}>Transcriptions</div>
                    <img className={styles.imageHistoryIcon} alt="Transcriptions" src="/icon-history.svg" />
                </Link>

                <div className={styles.copyright}>© 2025 Manaber</div>

                {user && (
                    <div className={styles.userInfoContainer}>
                        <p className={styles.userName}>{user.firstName} {user.lastName}</p>
                        <p className={styles.userEmail}>{user.email}</p>
                    </div>
                )}

                <button className={styles.logoutButton} onClick={handleLogout}>
                    Logout
                </button>
            </div>
        </>
    );
};

export default AdminSideMenu;
